/**
 * 用于移除请求参数内的空值字段（如null、''、undefined）
 * @param reservedValues 要保留的值的数组，默认保留0
 * @param parameterIndex 要处理的参数下标，默认0
 * @constructor
 */
export function ParamsClean (reservedValues: any[] = [0], parameterIndex = 0): MethodDecorator {
  return function (target: any, propertyKey: string | symbol, descriptor: PropertyDescriptor) {
    const originalMethod = descriptor.value
    if (typeof originalMethod !== 'function') {
      throw new Error(`@ParamsClean 只能用于方法，而 ${String(propertyKey)} 不是一个方法`)
    }

    descriptor.value = function (...args: any[]) {
      const paramToClean = args[parameterIndex]
      if (typeof paramToClean !== 'object' || paramToClean === null) {
        return originalMethod.apply(this, args)
      }
      const cleanedParam = cleanObject(paramToClean, reservedValues)
      const newArgs = [...args]
      newArgs[parameterIndex] = cleanedParam
      return originalMethod.apply(this, newArgs)
    }
    return descriptor
  }
}

/**
 * 递归清理对象中的空值字段
 */
function cleanObject (obj: any, reservedValues: any[]): any {
  if (obj === null || obj === undefined) {
    return obj
  }

  if (Array.isArray(obj)) {
    return obj.map(item => cleanObject(item, reservedValues))
  }

  if (typeof obj === 'object') {
    const result: any = {}
    Object.keys(obj).forEach(key => {
      const value = obj[key]
      if (reservedValues.includes(value)) {
        result[key] = value
        return
      }
      if (typeof value === 'object' && value !== null) {
        const cleanedValue = cleanObject(value, reservedValues)
        if (Array.isArray(cleanedValue) && cleanedValue.length > 0 ||
          !Array.isArray(cleanedValue) && Object.keys(cleanedValue).length > 0) {
          result[key] = cleanedValue
        }
        return
      }
      if (value !== null && value !== undefined && value !== '') {
        result[key] = value
      }
    })
    return result
  }
  return obj
}
